export default "__VITE_ASSET__d124efca__"